import Server from './server';
// import Global from '../global';

class Api extends Server {
  /**
   * 登录
   */
  async login(params) {
    const err = {
      tip: '暂无法登录，请稍后重试',
      data: params,
    };
    try {
      const url = '/paywages/api/login';
      const result = await this.axios('post', url, params);
      if (result && result.status === 0) {
        return result;
      }
      if (result.status === 1) {
        err.tip = '暂无支付权限，请联系管理员';
      }
      err.response = result;
      err.url = url;
      throw err;
    } catch (error) {
      err.response = error;
      throw err;
    }
  }

  /**
   * 登出
   */
  async logout() {
    try {
      const url = '/paywages/api/logout';
      const result = await this.axios('post', url);
      if (result && result.status === 0) {
        return result;
      }
      const err = {
        tip: '登出失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 文件上传
   */
  async upload(formData) {
    try {
      const url = '/paywages/api/excel/import';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法上传 excel 文件，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * excel 导入历史记录
   */
  async fetchUser() {
    try {
      const url = '/paywages/api/user';
      const result = await this.axios('get', url);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法获取登录用户信息，请稍后重试',
        response: result,
        data: {},
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * excel 导入历史记录
   */
  async fetchExcelImports(formData) {
    try {
      const url = '/paywages/api/excel/import';
      const result = await this.axios('get', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取 excel 导入历史记录，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * excel 导入历史记录
   */
  async fetchExcelDetail(formData) {
    try {
      const url = '/paywages/api/excel/detail';
      const result = await this.axios('get', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '文件上传失败',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 转账明细
   */
  async fetchPayDetail(formData) {
    try {
      const url = '/paywages/api/pay/detail';
      const result = await this.axios('get', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '文件上传失败',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 明细总数
   */
  async fetchPayDetailCount(formData) {
    try {
      const url = '/paywages/api/pay/detail/count';
      const result = await this.axios('get', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '文件上传失败',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 登出
   */
  async payEnable(params) {
    try {
      const url = '/paywages/api/excel/enable';
      const result = await this.axios('post', url, params);
      if (result && result.status === 0) {
        return result;
      }
      const err = {
        tip: '登出失败',
        response: result,
        data: params,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 回单上传
   */
  async uploadReceipt(formData) {
    try {
      const url = '/paywages/api/recharge/upload/receipt';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法上传回执文件，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取所有充值记录
   */
  async fetchAllRecharges(formData) {
    try {
      const url = '/paywages/api/recharge/all';
      const result = await this.axios('get', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取充值记录
   */
  async fetchRecharges(formData) {
    try {
      const url = '/paywages/api/recharge/list';
      const result = await this.axios('get', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 新增充值记录
   */
  async addRecharge(formData) {
    try {
      const url = '/paywages/api/recharge/add';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法新增账户充值，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取充值记录
   */
  async fetchRechargeDetail(params) {
    try {
      const url = '/paywages/api/recharge/detail';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 新增充值记录
   */
  async auditRecharge(params) {
    try {
      const url = '/paywages/api/recharge/audit';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法新增账户充值，请稍后重试',
        response: result,
        data: {
          params,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取所有平台
   */
  async fetchPlatforms() {
    try {
      const url = '/paywages/api/platforms';
      const result = await this.axios('get', url);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          params,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取所有供应商
   */
  async fetchProviders() {
    try {
      const url = '/paywages/api/providers';
      const result = await this.axios('get', url);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          params,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取当前账号对应供应商
   */
  async fetchProviderDetail() {
    try {
      const url = '/paywages/api/provider/detail';
      const result = await this.axios('get', url);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          params,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 新增平台
   */
  async addPlatform(formData) {
    try {
      const url = '/paywages/api/platform/add';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法新增，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 新增供应商
   */
  async addProvider(formData) {
    try {
      const url = '/paywages/api/provider/add';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法新增，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取供应商对应平台
   */
  async fetchPlatformsByProviderId(params) {
    try {
      const url = '/paywages/api/platforms/providerid';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          params,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 新增账号
   */
  async addAccount(formData) {
    try {
      const url = '/paywages/api/account/add';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法新增，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取所有平台
   */
  async fetchProviderTotalMoney(params) {
    try {
      const url = '/paywages/api/recharge/money';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          params,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  async fetchMoneyView(params) {
    try {
      const url = '/paywages/api/money/view';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂未获取充值记录，请稍后重试',
        response: result,
        data: {
          params,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 基本信息
   */
  async fetchBasicInfo(params) {
    try {
      const url = '/paywages/api/basic/info';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '文件上传失败',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   *
   */
  async addLimitUser(formData) {
    try {
      const url = '/paywages/api/add/limituser';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '文件上传失败',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   *
   */
  async fetchLimitUsers(params) {
    try {
      const url = '/paywages/api/limitusers';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法操作，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  async changePwd(data) {
    try {
      const url = '/paywages/api/account/change/passwd';
      const result = await this.axios('post', url, data);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法操作，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  async fetchAccounts(params) {
    try {
      const url = '/paywages/api/accounts';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法操作，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 文件上传
   */
  async uploadBankFile(formData) {
    try {
      const url = '/paywages/api/bank/account/verify';
      const result = await this.axios('post', url, formData);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '暂无法上传 excel 文件，请稍后重试',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取未审核记录
   */
  async fetchUnhandleRecharges() {
    try {
      const url = '/paywages/api/recharge/unhandle';
      const result = await this.axios('get', url);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '文件上传失败',
        response: result,
        data: {
          formData,
        },
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取发票列表
   */
  async getInvoiceList(params) {
    try {
      const url = '/paywages/api/invoice/list';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        message: result.msg || '获取发票列表失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }
  /**
   * 新增发票申请
   */
  async addInvoiceApply(params) {
    try {
      const url = '/paywages/api/invoice/add';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票新增失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }
  /**
   * 提交发票审核
   */
  async postInvoiceAudit(params) {
    try {
      const url = '/paywages/api/invoice/manage/audit';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票审核失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }
  /**
   * 发票审核
   */
  async addInvoiceAudit(params) {
    try {
      const url = '/paywages/api/invoice/add';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: '发票审核失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }
  /**
   * 新增服务事项
   */
  async addServiceItem(params) {
    try {
      const url = '/paywages/api/invoice/serviceitem/add';
      const result = await this.axios('post', url, params);

      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '服务事项新增失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取发票服务事项
   */
  async getServiceList() {
    try {
      const url = '/paywages/api/invoice/serviceitem/all';
      const result = await this.axios('get', url);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '服务事项获取失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 新增发票类别
   */
  async addInvoiceClass(params) {
    try {
      const url = '/paywages/api/invoice/class/add';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票类别新增失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 编辑发票类别
   */
  async editInvoiceClass(params) {
    try {
      const url = '/paywages/api/invoice/class/update';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票类别编辑失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取发票类别
   */
  async getInvoiceClassList(params) {
    try {
      const url = '/paywages/api/invoice/class/list';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票类别新增失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 发票物流信息编辑
   */
  async editInvoiceTick(params) {
    try {
      const url = '/paywages/api/invoice/manage/trick';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票物流信息编辑失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取合同列表
   */
  async getContractList(params) {
    try {
      const url = '/paywages/api/contract/list';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '合同列表获取失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 编辑企业合同信息
   */
  async editContractInfo(params) {
    try {
      const url = '/paywages/api/contract/save';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '合同编辑失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 生成企业合同
   */
  async generateContract() {
    try {
      const url = '/paywages/api/contract/generate';
      const result = await this.axios('post', url);
      if (result.status === 0) {
        return result.status;
      }
      const err = {
        tip: result.msg || '暂无法生成企业合同，请稍后重试',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 获取完税证明列表
   */
  async getTaxList(params) {
    try {
      const url = '/paywages/api/tax/list';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '合同列表获取失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 生成上月完税证明
   */
  async generateTax() {
    try {
      const url = '/paywages/api/tax/generate';
      const result = await this.axios('post', url);
      if (result.status === 0) {
        return result.status;
      }
      const err = {
        tip: result.msg || '暂无法生成完税证明，请稍后重试',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 生成个人上月完税证明
   */
  async generatePersonTax() {
    try {
      const url = '/paywages/api/tax/personal/generate';
      const result = await this.axios('post', url);
      if (result.status === 0) {
        return result.status;
      }
      const err = {
        tip: result.msg || '暂无法生成完税证明，请稍后重试',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  async uploadTick(params) {
    try {
      const url = '/paywages/api/file/upload';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票上传失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  async exportInvoiceInfo(params) {
    try {
      const url = '/paywages/api/invoice/export';
      const result = await this.axios('get', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '文件下载失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  async uploadTax(params) {
    try {
      const url = '/paywages/api/tax/upload';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '完税证明文件失败',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  fileDownload(params) {
    try {
      const queryArr = [];
      Object.keys(params).forEach((key) => {
        queryArr.push(`${key}=${params[key]}`);
      });
      const queryStr = queryArr.join('&');

      const url = '/paywages/api/file/download';
      window.location = `${url}?${queryStr}`;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 编辑企业合同信息
   */
  async editInvoiceClassStatus(params) {
    try {
      const url = '/paywages/api/invoice/class/status';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '发票类目启用/停用错误',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadContract(params) {
    try {
      const queryArr = [];
      Object.keys(params).forEach((key) => {
        queryArr.push(`${key}=${params[key]}`);
      });
      const queryStr = queryArr.join('&');

      const url = '/paywages/api/contract/export';
      window.location = `${url}?${queryStr}`;
    } catch (err) {
      throw err;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadInvoices(params) {
    try {
      const queryArr = [];
      Object.keys(params).forEach((key) => {
        queryArr.push(`${key}=${params[key]}`);
      });
      const queryStr = queryArr.join('&');

      const url = '/paywages/api/invoice/export';
      window.location = `${url}?${queryStr}`;
    } catch (err) {
      throw err;
    }
  }

  /**
   * 用户信息
   */
  async fetchUsers(params) {
    const err = {
      tip: '暂无法登录，请稍后重试',
      data: params,
    };
    try {
      const url = '/paywages/api/users/v2';
      const result = await this.axios('get', url, params);
      if (result && result.code === 'ok') {
        return result;
      }
      console.log(result);
      err.response = result;
      err.url = url;
      throw err;
    } catch (error) {
      err.response = error;
      throw err;
    }
  }

  /**
   * 用户详情
   */
  async fetchUserDetail(params) {
    const err = {
      tip: '暂无法登录，请稍后重试',
      data: params,
    };
    try {
      const url = '/paywages/api/user/detail/v2';
      const result = await this.axios('get', url, params);
      if (result && result.code === 'ok') {
        return result;
      }
      console.log(result);
      err.response = result;
      err.url = url;
      throw err;
    } catch (error) {
      err.response = error;
      throw err;
    }
  }

  async payChangeStatus(params) {
    try {
      const url = '/paywages/api/pay/change/status';
      const result = await this.axios('post', url, params);
      if (result.status === 0) {
        return result.data;
      }
      const err = {
        tip: result.msg || '暂无法操作，请稍后重试',
        response: result,
        url,
      };
      throw err;
    } catch (err) {
      throw err;
    }
  }
}

export default new Api();



// WEBPACK FOOTER //
// ./src/api/api.js